import styled from 'styled-components';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: row;
`